export enum MessageType {
  Text = '1'
}
